#import "../fragments/account-page-fragment.graphql"

mutation UpdateAccount($input: AccountUpdateInput!) {
    accountUpdate(input: $input) {
        account {
            ...AccountPageFragment
        }
    }
}
